import moment from 'moment-timezone';
import React from 'react';

import { ReactComponent as Calendar } from '../../../assets/icons/Calendar.svg';
import utils from '../../../services/utils';

import classes from './DeleteInvoiceCard.module.scss';

const DeleteInvoiceCard = ({ className, date, pendingValue, description, isAgreement }) => {
  const contentClasses = [classes.card];

  className && contentClasses.push(className);

  return (
    <div className={contentClasses.join(' ')}>
      <span className={`${classes.color} medium-16`}>{description ? description : 'N/A'}</span>
      <div className={classes.date}>
        <Calendar />{' '}
        <span className={`${classes.color} medium-16`}>
          {isAgreement ? 'Se vence el ' : 'Se emitió el '}
          {moment(date).format('DD/MM/YYYY')}
        </span>
      </div>
      <span className='semibold-18'>{utils.moneyFormat(pendingValue)} pendientes</span>
    </div>
  );
};

export default DeleteInvoiceCard;
